import useAuth from "../hooks/useAuth";

// Permissions come with the user's role (e.g. 'Admin') or are granted to the user directly (e.g. 'Send_mobilepay').
export default function HasPermission(permissions) {
    const { auth } = useAuth();
    return (auth.permissions ?? []).some(permission => permissions.includes(permission))
}
